export default __webpack_public_path__ + "static/media/icon-footer-instagram.766ec0d1.svg";